export default {
  searchBlogsStatus: '',
  searchBlogsCategory: ''
}



// WEBPACK FOOTER //
// ./src/components/blogs/store/state.js